export function orgTo(org: Organization) {
  return `/organization/${org.id}`
}
